export const surveyColumns = [
    {
        title: "MD",
        dataIndex: "md",
        key: "md",
        width: "32.5%",
    },
    {
        title: "INC",
        dataIndex: "inc",
        key: "inc",
        width: "30%",
    },
    {
        title: "DLS",
        dataIndex: "dls",
        key: "dls",
        width: "30%",
        render: (
            text: string,
        ) => (
            <div className="flex items-center">
                <div className="flex items-center rounded text-[14px] border py-1 px-2 text-success-400 border-success-400 font-semibold min-w-[50px]">
                    {text}
                </div>
            </div>
        ),
    },
];
